<template>
  <div>
    <div>
      <div class="headerContent">
        <div class="contentWrap1">
          <p>签约操作</p>
        </div>
      </div>
      <div class="flow">
        <div class="headerWrap">
          <div class="rightText">
            <div>
              <div class="selectText">划出系统</div>
              <el-select
                v-model="from"
                clearable
                placeholder="请选择"
                popper-class="selStyle"
                @change="change"
              >
                <el-option
                  v-for="(item, index) in BaseMarkets"
                  :key="index"
                  :value="item.marketId"
                  :label="item.accountName"
                ></el-option>
                <!-- <el-option
                  v-for="(item, index) in BaseMarkets"
                  :key="index"
                  :value="item.userAccountid"
                  :label="item.accountName"
                ></el-option> -->
              </el-select>
              <div class="selectText">划入系统</div>
              <el-select
                v-model="to"
                clearable
                placeholder="请选择"
                popper-class="selStyle"
                @change="changes"
              >
                <el-option
                  v-for="(item, index) in BaseMarkets"
                  :key="index"
                  :value="item.marketId"
                  :label="item.accountName"
                ></el-option>
              </el-select>
              <div class="selectText">划转金额</div>
              <div>
                <el-input v-model="number" placeholder="请输入" />
              </div>
              <p style="width:200px;padding-left:10px;color: #909399;">可划转金额为{{ canBeMargin }}</p>
            </div>
            <div>
              <div class="selectText">资金密码</div>
              <div>
                <el-input v-model="pwd" type="password" auto-complete="new-password" placeholder="请输入" />
              </div>
              <el-button
                type="danger"
                :disabled="disable"
                :loading="loading"
                @click="submit()"
              ><span style="color:#fff">确认</span></el-button>
              <el-button type="primary" @click="resetData"><span style="color:#fff">重填</span></el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="headerContent">
        <div class="contentWrap1">
          <p>划转流水查询</p>
        </div>
      </div>
      <!-- 出入金流水 -->
      <div class="flow">
        <div class="tableWrap">
          <el-table :data="tableData" border style="width: 100%">
            <template slot="empty">
              <div class="no-datas1">
                <div
                  class="no-data-img"
                  style="margin: 100px auto 0px; width: 120px; height: 200px;"
                >
                  <img
                    src="../../../assets/images/no_data.png"
                    alt=""
                    style="width: 100%;"
                  >
                </div>
              </div>
            </template>
            <el-table-column align="center" prop="flowId" label="记录流水号">
            </el-table-column>
            <el-table-column align="center" prop="accountOut" label="划出系统">
            </el-table-column>
            <el-table-column align="center" prop="accountIn" label="划入系统">
            </el-table-column>
            <el-table-column align="center" prop="amount" label="划转金额">
            </el-table-column>
            <el-table-column align="center" prop="balance" label="余额">
            </el-table-column>
            <el-table-column prop="occurTime" label="划转时间" width="180">
              <template slot-scope="scope">
                {{ scope.row.occurTime | dateFormate }}
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
        popper-class='_popStyle'
            :current-page="pageData.currentPage"
            :page-sizes="pageData.pageSizes"
            :page-size="pageData.pageSize"
            layout="total, sizes, prev, pager, next"
            :total="pageData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/*global http protocol protocolTrans*/
import md5 from 'js-md5'
export default {
  data() {
    return {
      myAsset: [],
      showMarketId: window.g.APP_show_marketId,
      loading: false,
      disable: false,
      fromMarketId: null,
      toMarketId: null,
      canBeMargin: null,
      from: null,
      to: null,
      number: '',
      pwd: '',
      selectData: '',
      typeCode: null,
      tableData: [],
      pageData: {
        total: 0,
        pageSizes: [5, 10, 20],
        pageSize: 10,
        currentPage: 1
      }
    }
  },
  computed: {
    BaseMarkets() {
      let arr = window.g.APP_market
      let retarr = []
      for (let i = 0; i < arr.length; i++) {
        let mitem = {
          accountName: "",
          balance: 0.0,
          createTime: '',
          frozenFunds: 0.0,
          marketId: null,
          signFlag: '',
          updateTime: '',
          userAccountid: '',
          userId: '',
        }
        mitem.marketId = arr[i].marketId
        mitem.accountName = arr[i].accountName
        retarr.push(mitem)
      }
      return retarr
    }
  },
  mounted() {
    this.findMyAsset()
    this.param_findAccountByUserId1()
    this.param_queryMyIntegralDetail()
  },
  methods: {
    resetData() {
      this.from = null
      this.to = null
      this.number = ''
      this.pwd = ''
      this.canBeMargin = '--'
    },
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.param_queryMyIntegralDetail()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.param_queryMyIntegralDetail()
    },
    changeContent() {
      const temp = this.from
      this.from = this.to
      this.to = temp
      var firmList = JSON.parse(localStorage.getItem('FirmIdList_w'))
      if (this.from == null) {
        this.canBeMargin = '---'
        for (let i = 0; i < firmList.length; i++) {
          // 20220224 userAccountid
          if (firmList[i].marketId == this.to) {
            this.toMarketId = firmList[i].marketId
          }
        }
      } else {
        this.firmArr = []
        for (let i = 0; i < firmList.length; i++) {
          // 20220224 userAccountid
          if (firmList[i].marketId == this.from) {
            this.firmArr.push(firmList[i].firmId)
            this.fromMarketId = firmList[i].marketId
          }
          // 20220224 userAccountid
          if (firmList[i].marketId == this.to) {
            this.toMarketId = firmList[i].marketId
          }
        }
        this.searchMoney(this.fromMarketId)
      }
    },
    // 查看更多
    moreShow() {
      this.$router.push('/financialRecord')
    },
    param_findAccountByUserId1() {
      this.firmArr = []
      http.postFront(protocolTrans.param_findAccountByUserId).then(response => {
        if (response.data) {
          if (response.data && response.data.code == '0') {
            // this.BaseMarkets = response.data.value
            this.BaseMarkets.forEach((item, idx) => {
              if (item.marketId == 0) {
                this.BaseMarkets.splice(idx, 1)
                this.BaseMarkets.splice(0, 0, item)
              }
            })
            // var newData = []
            // this.BaseMarkets.forEach(item => {
            //   if (this.showMarketId.includes(item.marketId)) {
            //     newData.push(item)
            //   }
            // })
            // this.BaseMarkets = newData
            // this.getTopData()
            var firmList = JSON.parse(localStorage.getItem('FirmIdList_w'))
            for (let i = 0; i < firmList.length; i++) {
              // 20220224 查找对应市场用户id
              this.BaseMarkets.forEach((value, idx) => {
                if(firmList[i].marketId == this.BaseMarkets[idx].marketId) {
                  this.BaseMarkets[idx].userAccountid = firmList[i].userAccountid
                }
              })

              // if (
              //   firmList[i].userAccountid == this.BaseMarkets[0].userAccountid
              // ) {
              //   this.fromMarketId = firmList[i].marketId
              //   this.firmArr.push(firmList[i].firmId)
              // }
              // 20220224 marketId判断初渲染可划出余额
              if (
                firmList[i].marketId == this.BaseMarkets[0].marketId
              ) {
                this.fromMarketId = firmList[i].marketId
                this.firmArr.push(firmList[i].firmId)
              }
            }
            this.searchMoney(this.fromMarketId)
            this.to = null
            this.number = ''
            this.selectMarket = {
              accountName: '',
              balance: 0.0,
              frozenFunds: 0.0,
              userAccountid: 0,
              userId: 0
            }
            // 20220224 userAccountid
            this.from = this.BaseMarkets[0].marketId
            this.firstUser = this.BaseMarkets[0].marketId

            if (this.asd != null) {
              for (let i = 0; i < this.BaseMarkets.length; i++) {
                const element = this.BaseMarkets[i]
                // 20220224
                if (element.marketId === this.asd) {
                  this.selectMarket = element
                }
              }
            }
          }
        }
      })
    },
    // 资金划转市场列表
    param_findAccountByUserId() {
      this.firmArr = []
      http.postFront(protocolTrans.param_findAccountByUserId).then(response => {
        if (response.data) {
          if (response.data && response.data.code == '0') {
            this.BaseMarkets = response.data.value
            var firmList = JSON.parse(localStorage.getItem('FirmIdList_w'))
            for (let i = 0; i < firmList.length; i++) {
              // 20220224 userAccountid
              if (firmList[i].marketId == this.from) {
                this.fromMarketId = firmList[i].marketId
                this.firmArr.push(firmList[i].firmId)
              }
            }
            const that = this
            setTimeout(() => {
              // this.getTopData()
              this.$message(response.data.message)
              that.loading = false
              // that.to = null;
              that.number = ''
              that.selectMarket = {
                accountName: '',
                balance: 0.0,
                frozenFunds: 0.0,
                userAccountid: 0,
                userId: 0
              }
              that.searchMoney(this.fromMarketId)
              // that.from = that.BaseMarkets[0].userAccountid;
            }, 1500)

            this.firstUser = this.BaseMarkets[0].userAccountid
            if (this.asd != null) {
              for (let i = 0; i < this.BaseMarkets.length; i++) {
                const element = this.BaseMarkets[i]
                // 20220224
                if (element.marketId === this.asd) {
                  this.selectMarket = element
                }
              }
            }
          }
        }
      })
    },
    // 查询划转记录
    param_queryMyIntegralDetail() {
      protocol.param_queryFundsTransfer.param.sort = [
        {
          direction: 'DESC', // "//DESC或ASC",
          property: 'occurTime' // "//排序属性"
        }
      ]
      protocol.param_queryFundsTransfer.param.page =
        this.pageData.currentPage - 1
      protocol.param_queryFundsTransfer.param.size = this.pageData.pageSize
      http.postFront(protocol.param_queryFundsTransfer).then(response => {
        const { code, message, value } = response.data
        if (Number(code) == 0) {
          const arr = value.content
          this.tableData = arr
          this.pageData.total = value.totalElements
        } else {
          this.$message(message)
        }
      })
    },
    findMyAsset() {
      http.postFront(protocol.param_findMyAsset).then(response => {
        const { code, message, value } = response.data
        if (Number(code) === 0) {
          if (value.length != 0) {
            this.myAsset = value
          }
        } else {
          this.$message(message)
        }
      })
    },
    //  可划转资金
    searchMoney(marketId) {
      console.log('marketId', marketId)
      this.myAsset.forEach(item => {
        if (Number(marketId) === Number(item.marketId)) {
          console.log(item)
          this.canBeMargin = item.availableFunds
        }
      })
    },
    // 资金来源
    change(selOption) {
      if (selOption === this.to) {
        this.$message('两次选择账户相同,请重新选择')
        this.from = null
        return
      }
      this.firmArr = []
      var firmList = JSON.parse(localStorage.getItem('FirmIdList_w'))
      for (let i = 0; i < firmList.length; i++) {
        // 20220224
        if (firmList[i].marketId == selOption) {
          this.firmArr.push(firmList[i].firmId)
          this.fromMarketId = firmList[i].marketId
          // 20220224
          this.fromUserAccountId = firmList[i].userAccountid
        } else {
          // 20220224
          this.canBeMargin = 0
          this.fromMarketId = selOption
        }
      }

      this.searchMoney(this.fromMarketId)

      this.asd = selOption
      this.selectMarket = {
        accountName: '',
        balance: 0.0,
        frozenFunds: 0.0,
        userAccountid: 0,
        userId: 0
      }
      for (let i = 0; i < this.BaseMarkets.length; i++) {
        const element = this.BaseMarkets[i]
        if (element.userAccountid === selOption) {
          this.selectMarket = element
        }
      }
    },

    // 资金去向
    changes(selOption) {
      if (selOption === this.from && selOption === this.firstUser) {
        this.from = null
        return
      } else if (selOption === this.from) {
        this.$message('划出系统与划入系统不能相同，请重新选择')
        this.to = null
        return
      }
      var firmList = JSON.parse(localStorage.getItem('FirmIdList_w'))
      for (let i = 0; i < firmList.length; i++) {
        // 20220224
        if (firmList[i].marketId == selOption) {
          this.toMarketId = firmList[i].marketId
          // 20220224
          this.toUserAccountId = firmList[i].userAccountid
        } else {
          // 20220224
          this.toMarketId = selOption
        }
      }
    },
    submit() {
      var test1 = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/
      if (!this.number) {
        this.$message('划转金额未填写')
        return
      }
      // 20220224
      if ( this.from === '') {
        this.$message('请选择划出系统')
        return
      }
      if ( this.to === '') {
        this.$message('请选择划入系统')
        return
      }
      if (Number(this.number) <= 0) {
        this.$message('划转资金填写错误')
        return
      }
      if (!test1.test(Number(this.number))) {
        this.$message('划转资金最多为两位小数')
        return
      }
      if (Number(this.number) > Number(this.canBeMargin)) {
        this.$message('划转资金超额')
        return
      }
      if (this.from === this.to) {
        this.$message('划出系统与划入系统不能相同，请重新选择')
        return
      }
      if (!this.pwd) {
        this.$message('请输入资金密码')
        return
      }
      this.loading = true
      this.param_transferFundsOwn()
    },
    // 资金划转(多市场间划转)
    param_transferFundsOwn() {
      this.disable = true
      protocolTrans.param_transferFundsOwn.param.amount = this.number
      protocolTrans.param_transferFundsOwn.param.pwd = md5(
        '47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU=' + this.pwd
      )
      // 20220224 fromUserAccountId、toUserAccountId取消传参
      // protocolTrans.param_transferFundsOwn.param.fromUserAccountId = this.fromUserAccountId
      // protocolTrans.param_transferFundsOwn.param.toUserAccountId = this.toUserAccountId
      protocolTrans.param_transferFundsOwn.param.fromMarketId = this.fromMarketId
      protocolTrans.param_transferFundsOwn.param.toMarketId = this.toMarketId
      http.postFrontMk0(protocolTrans.param_transferFundsOwn).then(response => {
        const { code, message } = response.data
        // this.$message(message);
        if (Number(code) === 0) {
          this.disable = false
          this.number = ''
          this.pwd = ''
          this.from = ''
          this.to = ''
          this.fromMarketId = ''
          this.toMarketId = ''
          this.canBeMargin = '--'
          this.param_findAccountByUserId()
          setTimeout(() => {
            this.param_queryMyIntegralDetail()
            this.findMyAsset()
          }, 4000)
        } else {
          this.loading = false
          this.disable = false
          this.$message(message)
        }
      })
    },
    //
    getTopData() {
      this.topData = []
      var firmList = JSON.parse(localStorage.getItem('FirmIdList_w'))
      const arr = []
      for (let i = 0; i < firmList.length; i++) {
        arr.push(firmList[i].firmId)
      }
      protocolTrans.param_mineAsset1.param.firmIds = arr
      http.postFront(protocolTrans.param_mineAsset1).then(response => {
        const { code, message, value } = response.data
        if (Number(code) === 0) {
          this.BaseMarkets.forEach(item1 => {
            value.forEach(item => {
              if (item.firmId == item1.firmId) {
                const obj = {}
                obj.text = item.canBeMargin
                obj.title = item1.accountName
                this.topData.push(obj)
              }
            })
          })
        } else {
          this.$message(message)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.headerContent {
  height: 40px;
  line-height: 40px;
  margin: 20px 0;
  background: linear-gradient(180deg, #1f243c 0%, #323855 100%);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
  .contentWrap1 {
    p {
      padding-left: 20px;
      font-size: 18px;
      font-weight: 600;
      color: rgba(255, 255, 255, 0.6);
    }
  }
}
.flow {
  /deep/ .el-table {
    min-height: calc(100vh - 420px);
    background: #141625;
  }
  /deep/ .el-table__body-wrapper {
    min-height: calc(100vh - 420px);
  }
  .headerWrap {
    height: 40px;
    line-height: 40px;
    // padding: 0 20px;
    margin-bottom: 13px;
    margin-top: 13px;
    .leftText {
      font-size: 20px;
      font-weight: 500;
      color: #ffffff;
    }
    .rightText {
      display: flex;
      // justify-content: space-between;
      font-size: 16px;
      color: rgba(255, 255, 255, 0.6);
      /deep/ .el-input {
        width: 130px;
      }
      .selectText {
        width: 90px;
        color: rgba(255, 255, 255, 0.6);
        text-align: center;
      }
      /deep/ .el-input__inner {
        height: 34px;
        line-height: 34px;
        color: rgba(255, 255, 255, 0.8);
        background-color: transparent;
        border: 1px solid rgba(220, 223, 230, 0.3);
      }
      /deep/ .el-date-editor .el-range-input {
        background-color: transparent;
      }
      .el-button {
        height: 34px;
        margin: 0 10px;
        padding: 0 25px;
        margin-top: 4px;
      }
      .el-button + .el-button {
        margin-left: 0;
      }
    }
    .rightText > div {
      display: flex;
    }
  }
}
</style>
<style lang='scss'>
.selStyle {
  .el-select-dropdown__item.selected{
    text-align: left !important;
  }
  .el-scrollbar__wrap{
    margin-right: -8px !important;
    margin-bottom: -8px !important;
  }
}
</style>
